import { render, staticRenderFns } from "./BodyText.vue?vue&type=template&id=632945b9&"
import script from "./BodyText.vue?vue&type=script&lang=js&"
export * from "./BodyText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('632945b9')) {
      api.createRecord('632945b9', component.options)
    } else {
      api.reload('632945b9', component.options)
    }
    module.hot.accept("./BodyText.vue?vue&type=template&id=632945b9&", function () {
      api.rerender('632945b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/View/BodyText.vue"
export default component.exports